export default {
  code: '404',
  title: 'Seite nicht gefunden',
  description: 'Die gesuchte Seite existiert nicht oder ist nicht mehr verfügbar.',
};
